import Vue from 'vue'
import Router from 'vue-router'
import CesiumView from './views/cesium-view/cesium-view'
import AppAuth from './views/app-auth/app-auth'

import firebase from 'firebase/app'
import 'firebase/auth'

Vue.use(Router);

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            name: 'cesium-view',
            component: CesiumView,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/auth',
            name: 'app-auth',
            component: AppAuth
        },
        {path: '*', redirect: '/'}
    ]
});

router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.requiresAuth)) {
        if (firebase.auth().currentUser) next();
        else next({
            path: '/auth'
        })
    } else {
        next();
    }
});

export default router;